var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSrArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7708 0H10.2083L17.4999 10.2083L10.2083 20.4167H16.7708L24.0624 10.2083L16.7708 0Z",
    fill: "#031729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 0H0L7.29167 10.2083L0 20.4167H6.5625L13.8542 10.2083L6.5625 0Z",
    fill: "#031729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrArrow);
export default __webpack_public_path__ + "static/media/SRArrow.06d3250453acce68c8fee7653a2e1e1c.svg";
export { ForwardRef as ReactComponent };